import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const objections = [{
  q: '🤔 No tengo tiempo para leer un manual entero...',
  a: 'Justamente por eso lo diseñamos así. Está pensado para consulta rápida en plena guardia: tablas, planillas, algoritmos e infografías. No tenés que "leerlo" entero, lo abrís cuando lo necesitás y encontrás la respuesta en menos de 30 segundos.'
}, {
  q: '💸 ¿Vale la pena el precio?',
  a: 'Un solo error de medicación evitado, un registro que te cubre legalmente o una urgencia resuelta a tiempo ya pagaron el manual muchas veces. Y con la oferta de hoy, te sale menos que un par de cafés por módulo.'
}, {
  q: '📱 ¿Lo puedo usar desde el celular en la guardia?',
  a: '100%. Es PDF optimizado para mobile. Lo descargás una vez y lo tenés disponible offline. Pensado para usarlo entre paciente y paciente, sin depender de wifi ni de la compu del office.'
}, {
  q: '👩‍⚕️ Soy estudiante de enfermería, ¿me sirve?',
  a: 'Muchísimo. Es la transición perfecta entre lo que ves en el instituto y la realidad del turno. Te adelanta lo que vas a necesitar el día que estés sola frente al paciente.'
}, {
  q: '📊 ¿Las planillas de Excel realmente funcionan?',
  a: 'Sí. Vienen con las fórmulas ya cargadas: el balance hídrico se suma solo, el goteo se calcula automático y las escalas de Morse y Braden te dan el nivel de riesgo al instante. Cargás los datos y la planilla decide.'
}, {
  q: '⚡ ¿Cómo lo recibo?',
  a: 'De forma INMEDIATA. Apenas confirmás el pago, te llega un email con el link de descarga. En menos de 2 minutos lo tenés en tu celular o computadora.'
}];
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-pastel-100 px-4" data-id="element-115">
      <div className="max-w-3xl mx-auto" data-id="element-116">
        <div className="text-center mb-12" data-id="element-117">
          <div className="inline-flex items-center justify-center p-3 bg-navy-800 text-white rounded-full mb-4" data-id="element-118">
            <HelpCircle size={24} data-id="element-119" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-3" data-id="element-120">
            Preguntas frecuentes
          </h2>
          <p className="text-navy-700" data-id="element-121">
            Resolvé tus dudas antes de comprar. Acá las respuestas honestas.
          </p>
        </div>

        <div className="space-y-3" data-id="element-122">
          {objections.map((obj, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white border border-pastel-200 rounded-xl overflow-hidden shadow-sm" data-id="element-123">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-124">
                  <span className="font-bold text-navy-900 pr-4" data-id="element-125">{obj.q}</span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="text-navy-500 shrink-0" data-id="element-126">
                    <ChevronDown size={20} data-id="element-127" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-128">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-129">
                      <div className="px-5 pb-5 pt-1 border-t border-pastel-100" data-id="element-130">
                        <p className="text-navy-700 text-sm md:text-base leading-relaxed mt-3" data-id="element-131">
                          {obj.a}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-10" data-id="element-132">
          <a href="#compra" className="inline-block px-8 py-4 bg-navy-800 hover:bg-navy-700 text-white font-bold rounded-xl shadow-lg transition-all transform hover:-translate-y-1" data-id="element-133">
            Quiero llegar preparado a la guardia
          </a>
        </div>
      </div>
    </section>;
}